import { Component, computed, input, output, signal } from '@angular/core';
import { TranslocoModule } from '@jsverse/transloco';
import { GalleryService } from '../../media';
import { ImageUrlService } from '../../images';
import { Image, ImageRole } from '@frontend/core';
import { LoaderGlobeAnimationDetailComponent } from '../../../loaders';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'multisite-randomised-message-card',
  imports: [CommonModule,TranslocoModule,LoaderGlobeAnimationDetailComponent],
  templateUrl: './randomised-message-card.component.html',
  styleUrl: './randomised-message-card.component.scss'
})
export class RandomisedMessageCardComponent {

  cardWidth = input<string | undefined>('18rem');

  titleText = input<string | undefined>();
  titleTranslationKey = input<string | undefined>();
  titleTranslationScope = input<string | undefined>();
  titleClasses = input<string>('card-title font-weight-bold');
  randomTitleNumberMax = input<number | undefined>(undefined); // If 15, will randomly add number between 1 and 15, for example 'contributions.salutation.thanks.12'
  titleTranslationKeyRandomised = computed(() => {
    if (this.randomTitleNumberMax() !== undefined) {
      return `${this.titleTranslationKey()}.${Math.floor(Math.random() * this.randomTitleNumberMax()) + 1}`;
    }
    return this.titleTranslationKey();
  });

  descriptionText = input<string | undefined>(undefined);
  descriptionTranslationKey = input<string | undefined>(undefined);
  descriptionTranslationScope = input<string | undefined>(undefined);
  descriptionClasses = input<string | undefined>(undefined);
  randomDescriptionNumberMax = input<number | undefined>(undefined); // If 15, will randomly add number between 1 and 15, for example 'contributions.praise.intercultural_work.6'
  descriptionTranslationKeyRandomised = computed(() => {
    if (this.randomDescriptionNumberMax() !== undefined) {
      return `${this.descriptionTranslationKey()}.${Math.floor(Math.random() * this.randomDescriptionNumberMax()) + 1}`;
    }
    return this.descriptionTranslationKey();
  });

  captionText = input<string | undefined>(undefined);
  captionTranslationKey = input<string | undefined>(undefined);
  captionTranslationScope = input<string | undefined>(undefined);
  captionClasses = input<string>('small text-muted');
  randomCaptionNumberMax = input<number | undefined>(undefined); // If 15, will randomly add number between 1 and 15, for example 'contributions.captions.congrats.14'
  captionTranslationKeyRandomised = computed(() => {
    if (this.randomCaptionNumberMax() !== undefined) {
      return `${this.captionTranslationKey()}.${Math.floor(Math.random() * this.randomCaptionNumberMax()) + 1}`;
    }
    return this.captionTranslationKey();
  });

  buttonLabelText = input<string | undefined>(undefined); // 'Paris'
  buttonLabelTranslationKey = input<string | undefined>(undefined); // 'common.hq'
  buttonLabelTranslationScope = input<string | undefined>(undefined); // 'shop'
  buttonClicked = output<void>();

  gallery_role = input.required<ImageRole>();
  gallery_tags = input.required<string>();
  gallery = signal<Image[]>([]);
  loading = signal<boolean>(false);

  imageTransformations = input<string >('w_275,c_fill,ar_16:9/');

  randomImageUrl = computed(() => {
    if (this.gallery().length > 0) {
      const randomIndex = Math.floor(Math.random() * this.gallery().length);
      const image : Image = this.gallery()[randomIndex];
      return this.imageUrlService.build(image, this.imageTransformations());
    }
  });

  constructor(private galleryService: GalleryService, private imageUrlService: ImageUrlService) {
  }
  onButtonClicked() {
    this.buttonClicked.emit();
  }

  ngOnInit() {
    this.loading.set(true);
    this.galleryService.getGallery(this.gallery_role(), this.gallery_tags()).subscribe(gallery => {
      this.gallery.set(gallery.data);
      this.loading.set(true);
    },
    error => this.loading.set(false)
    );
  }

}
